/**
 * Renders the real Nine80 logo file — never recreated with CSS/text. Drop a
 * higher-resolution replacement at web/public/assets/nine80-logo.png and it's picked
 * up automatically (see docs/DEPLOYMENT.md "Updating the logo").
 */
export function Logo({
  className = 'h-16 w-auto',
  alt = 'Nine80 Hair Studio',
}: {
  className?: string;
  alt?: string;
}) {
  return (
    <img src="/assets/nine80-logo.png" alt={alt} className={className} width={200} height={150} />
  );
}
